import { putApi } from './common/apis';

export default class AccountService {
    async updateAccredition(payload) {
        const accreditionData = await putApi(`v1/accredition`, payload);
        return accreditionData;
    }
}
